import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getCourseOptions } from '@/module/Author/Course';
import { CourseEdit } from '@/module/Author/Course/CourseEdit';

export const Route = createFileRoute('/_auth/author/_author/course/_course/$courseId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { courseId } = Route.useParams();
  const { data: course } = useSuspenseQuery(getCourseOptions(courseId));

  return <CourseEdit course={course} />;
}
